import {useApp} from "./appContext";
import {animated, useSpring} from "@react-spring/web";
import {useEffect, useState} from "react";
import {LevelPackData} from "./models/levelData";
import {AppApi} from "./appApi";

function LevelWindow() {
    const {setSelectedLevel} = useApp();

    const springs = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
    })

    return (
        <animated.div className={'layout vertical'} style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.6)',
            alignItems: 'center',
            justifyContent: 'center',
            ...springs
        }} onClick={() => setSelectedLevel(undefined)}>
            <Box />
        </animated.div>
    )
}

function Box() {
    const {selectedLevel, setSelectedLevel} = useApp();
    const [levelPack, setLevelPack] = useState<LevelPackData | undefined>(undefined);

    const springs = useSpring({
        from: { x: -40, opacity: 0 },
        to: { x: 0, opacity: 1 },
    })

    useEffect(() => {
        const refreshLevel = async () => {
            const newLevelPack = await AppApi.getLevel(selectedLevel?.id ?? '');
            setLevelPack(newLevelPack);
        };

        refreshLevel();
    }, [selectedLevel]);

    if (!levelPack) {
        return <animated.div style={{
            backgroundColor: 'var(--overlay-color)',
            width: 900,
            height: 500,
            padding: 'var(--box-padding)',
            borderRadius: 20,
            ...springs
        }}/>
    }

    return (
        <animated.div style={{
            backgroundColor: 'var(--overlay-color)',
            width: 900,
            height: 500,
            padding: 'var(--box-padding)',
            borderRadius: 20,
            ...springs
        }} onClick={e => e.stopPropagation()}>
            <div className={'layout horizontal stretch center'}>
                <p className={'title'}>{levelPack.level.name}</p>
                <button onClick={() => setSelectedLevel(undefined)}>X</button>
            </div>
        </animated.div>
    )
}

export default LevelWindow;
